import { render, staticRenderFns } from "./tallaParaLaEdadNinos5a19A.vue?vue&type=template&id=f7e699aa&scoped=true"
import script from "./tallaParaLaEdadNinos5a19A.vue?vue&type=script&lang=js"
export * from "./tallaParaLaEdadNinos5a19A.vue?vue&type=script&lang=js"
import style0 from "./tallaParaLaEdadNinos5a19A.vue?vue&type=style&index=0&id=f7e699aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e699aa",
  null
  
)

export default component.exports